export default {
    url: '/employees',
    template: '<search-employees/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/search/employees/index.js